// extracted by mini-css-extract-plugin
export default {"container":"CharacterProfile_container__Ergl+","profile":"CharacterProfile_profile__xEJEy","difficulty":"CharacterProfile_difficulty__D6ydQ"};